/* eslint-disable react/jsx-indent */
import React, { useState } from 'react';
import { Form, Popover } from 'antd';
import { RemoteSelect } from 'react-structure-admin';

const FilterRemoteSelect = ({
  children,
  className,
  data,
  initialValue,
  isLast,
  name,
  multiple,
  placeholder,
  showSearch,
  label,
  resource,
  ...rest
}) => {
  const [visible, setVisible] = useState({ popover: false, select: false });

  const handleVisiblePopover = (value) => {
    setVisible({ ...visible, popover: visible.select ? false : value });
  };

  const handleVisibleSelect = (value) => {
    setVisible({ select: value, popover: false });
  };

  const getPlaceholder = (values) => {
    if (values.length <= 0) {
      return '';
    }

    if (values.length === 1) {
      return values[0].label;
    }

    return (
      <Popover
        title={placeholder}
        visible={visible.popover}
        onVisibleChange={handleVisiblePopover}
        placement="bottomLeft"
        content={
          <div>
            {values.map((c) => (
              <div key={c.key} className="gx-mb-1">
                {c.label}
              </div>
            ))}
          </div>
        }
      >
        {`${values.length} selecionados`}
      </Popover>
    );
  };

  return (
    <Form.Item
      name={name}
      noStyle={!label}
      initialValue={initialValue}
      label={label}
    >
      <RemoteSelect
        resource={resource}
        className={isLast ? '' : 'gx-mr-1  height-fixed'}
        showArrow
        showSearch={showSearch ?? false}
        placeholder={placeholder}
        style={{ width: '100%' }}
        maxTagPlaceholder={getPlaceholder}
        dropdownMatchSelectWidth={false}
        onDropdownVisibleChange={handleVisibleSelect}
        maxTagCount={0}
        {...rest}
      />
    </Form.Item>
  );
};

export default FilterRemoteSelect;
